import { Component } from '@angular/core';

/**
 * Component used as default for component data loading template.
 *
 * @class LoadingComponent
 * @implements {OnInit}
 */
@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'data-loading',
	templateUrl: './loading.component.html',
	styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
	public readonly GHOST_ROWS = Array(3).fill(0);
	public readonly GHOST_COLUMNS = Array(8).fill(0);
}
